import { TableName } from '../../../tables'
import { firstItem } from '../../../utils/listUtils'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Stock } from '../state/types'

export const useStockLoaders = () => {
    const systemHooks = useSystemStateHooks()
    
    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadAllStock = (dbRequest = false) => {
            const { loadAll } = loaders(companyId)
            return loadAll(TableName.STOCK, dbRequest) as Promise<Stock[]>
        }

        const loadBranchStocks = async (branchId: string) => {
            const { loadFiltered, hasLoaded, addToLoaded } = loaders(companyId)
            const stocks = await loadFiltered(TableName.STOCK, !hasLoaded(TableName.STOCK), { branchId }) as Stock[]
            addToLoaded(TableName.STOCK)
            return stocks
        }

        const loadProductStocks = (
            productId: string,
            branchId?: string,
            lotId?: string,
            dbRequest = false
        ) => {
            const { loadFiltered } = loaders(companyId)
            const params = {
                productId,
                ...(lotId && { lotId }),
                ...(branchId && { branchId })
            }
            return loadFiltered(TableName.STOCK, dbRequest, params) as Promise<Stock[]>
        }

        const loadProductStock = async (
            productId: string,
            branchId: string,
            lotId?: string,
            dbRequest = false
        ) => {
            const stocks = await loadProductStocks(productId, branchId, lotId, dbRequest)
            return firstItem(stocks)
        }

        return {
            loadAllStock,
            loadBranchStocks,
            loadProductStocks,
            loadProductStock
        }
    }
}
